<div class="notification-container">
    <button (click)="loadNotifications()">Refresh Notifications</button>
    <ul>
      <!-- <li *ngFor="let notification of notifications; let i = index" [ngClass]="{'unread': !notificationStatus[i]}">
        {{ notification }}
        <button (click)="markAsRead(i)">Mark as Read</button>
      </li> -->
    </ul>
  </div>
  